module.exports = __webpack_public_path__ + "img/advances-B.793c8421.svg";